import { Fragment, StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createBrowserHistory } from '@tanstack/react-router'

import { appState, initAppState } from '@/appState'

import '@/index.css'

import { initI18n } from './i18n'
import { router } from './router'

const main = async () => {
    const history = createBrowserHistory()

    try {
        await initI18n()
        await initAppState()
    } catch (error) {
        console.log('Error initializing app-root')
        console.error(error)
        appState?.sentry?.captureException(error)
        return
    }

    const RootWrapper = import.meta.env.DEV ? Fragment : StrictMode

    createRoot(document.getElementById('root')!).render(
        <RootWrapper>
            <RouterProvider router={router} history={history} />
        </RootWrapper>
    )
}

main()
